import { AUTH_CREDENTIALS } from '@ohif/app/src/configAuthentication'
// utils/fetchOverride.js
//CODIGO Y ARCHIVO CREADO POR RAMA, lo que hace es sobrescribir la solicitud FETCH global
//Esto se hizo para evitar la busqueda de autorizaciones en los multiples archivos del proyecto
// Guardamos una referencia al fetch original
const originalFetch = window.fetch;

// Usuario y contraseña para la autenticación básica
const credentials = btoa(`${AUTH_CREDENTIALS.username}:${AUTH_CREDENTIALS.password}`); // Codificación Base64

// Sobrescribimos el fetch
window.fetch = async (input, init = {}) => {
  // Aseguramos que existe el encabezado Authorization
  const headers = {
    ...init.headers,
    Authorization: `Basic ${credentials}`,
  };

  // Llamamos al fetch original con las configuraciones actualizadas
  return originalFetch(input, {
    ...init,
    headers,
  });
};
